import { createEntityAdapter } from '@reduxjs/toolkit';
import { StoreDetails } from '../type';

const storesAdapter = createEntityAdapter<StoreDetails>({});

export default storesAdapter;
